module.exports = __webpack_public_path__ + "static/CaviarDreams-webfont-5ac122f3eb7854a00d830f4874472b56.woff";